/* --------------------------------------------------------------------------
	Card Group
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	function init() {
		if (!$('.js-card-group-body').length) {
			return;
		}

		Site.OnResize.push(onResize);
	}

	function onResize() {
		if ($(window).width() >= Site.MinLG) {
			$('.js-card-group-body').removeAttr('role tabindex');
		} else {
			$('.js-card-group-body').attr({
				role: 'region',
				tabindex: '0'
			});
		}
	}

	Site.OnInit.push(init);
})(jQuery, Site);
